import { useForm } from 'react-hook-form'
import zod from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { ButtonLoader, Form } from '@wellesley/ui'
import { FC } from 'react'

import CommonFormField from 'components/form/CommonFormField'
import { usePostApiV1AccountsPasswordRecoverCheckCodeMutation } from '../../../../authApi'
import { TooManyAttempt } from '../../../TooManyAttempt'
import { fixedCacheKey } from '../ForgotPasswordPassCode/hooks/useSendPassCode'
import { useSubmit } from './useSubmit'
import { usernameOrEmailValidator, emailMaxLength } from '@wellesley/forms'
import { ForgotPasswordContainer } from '../ForgotPasswordContainer'
import { BackButton } from '../BackButton'

const formSchema = zod.object({
  login: usernameOrEmailValidator,
})

export type RegisterInput = zod.TypeOf<typeof formSchema>

export const ForgotPasswordRequest: FC = () => {
  const form = useForm<RegisterInput>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      login: '',
    },
  })
  const { control, handleSubmit } = form

  const [, codeState] = usePostApiV1AccountsPasswordRecoverCheckCodeMutation({
    fixedCacheKey,
  })

  const { onSubmit, isLoading, isError, error } = useSubmit()

  return (
    <Form {...form}>
      <form onSubmit={(...args) => void handleSubmit(onSubmit)(...args)}>
        <ForgotPasswordContainer description="Enter your email so we can send you a code <br /> to reset your password">
          <div>
            <TooManyAttempt
              message="The attempt was unsuccessful, please try again later"
              isError={codeState.isError || isError}
              error={codeState.error || error}
            />

            <CommonFormField
              control={control}
              name="login"
              displayName="Email or username"
              maxChars={emailMaxLength}
            />
            <div className="mt-m flex justify-stretch gap-xs">
              <BackButton className="flex-1" />
              <ButtonLoader
                type="submit"
                size="m"
                variant="primary"
                className="flex-1"
                isLoading={isLoading}
                disabled={!form.formState.isValid}
              >
                Send
              </ButtonLoader>
            </div>
          </div>
        </ForgotPasswordContainer>
      </form>
    </Form>
  )
}
